import React from 'react'
import i18n from 'i18next'

const SurveyUpdateWarnings = ({ warnings }) => {
    const {
        isSkipLogicAffected,
        isInheritanceAffected,
        invalidPageToPageLogic,
        invalidSkipToPageLogic,
        invalidShowPageLogic,
        invalidShowQuestionLogic,
        invalidShowOptionLogic,
        invalidInheritance,
    } = warnings

    if (!isSkipLogicAffected && !isInheritanceAffected) return null

    return (
        <div style={{ marginTop: '10px' }}>
            {invalidInheritance.length > 0 && (
                <div style={{ margin: '5px' }}>
                    <b>{i18n.t('surveyWarningModal.invalidInheritance')}</b>
                    <div style={{ padding: '10px' }}>
                        {invalidInheritance.map((invalid) => (<li>{invalid.child}</li>))}
                    </div>
                </div>
            )}
            {invalidPageToPageLogic.length > 0 && (
                <div style={{ margin: '5px' }}>
                    <b>{i18n.t('surveyWarningModal.pageToPage')}</b>
                    <div style={{ padding: '10px' }}>
                        {invalidPageToPageLogic.map((title) => (<li>{title}</li>))}
                    </div>
                </div>
            )}
            {invalidSkipToPageLogic.length > 0 && (
                <div style={{ margin: '5px' }}>
                    <b>{i18n.t('surveyWarningModal.skipToPage')}</b>
                    <div style={{ padding: '10px' }}>
                        {invalidSkipToPageLogic.map((title) => (<li>{title}</li>))}
                    </div>
                </div>
            )}
            {invalidShowPageLogic.length > 0 && (
                <div style={{ margin: '5px' }}>
                    <b>{i18n.t('surveyWarningModal.showPage')}</b>
                    <div style={{ padding: '10px' }}>
                        {invalidShowPageLogic.map((title) => (<li>{title}</li>))}
                    </div>
                </div>
            )}
            {invalidShowQuestionLogic.length > 0 && (
                <div style={{ margin: '5px' }}>
                    <b>{i18n.t('surveyWarningModal.showQuestion')}</b>
                    <div style={{ padding: '10px' }}>
                        {invalidShowQuestionLogic.map((title) => (<li>{title}</li>))}
                    </div>
                </div>
            )}
            {invalidShowOptionLogic.length > 0 && (
                <div style={{ margin: '5px' }}>
                    <b>{i18n.t('surveyWarningModal.showOption')}</b>
                    <div style={{ padding: '10px' }}>
                        {invalidShowOptionLogic.map((title) => (<li>{title}</li>))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default SurveyUpdateWarnings
